import axios, { handleResponse } from "utils/axios/public";
import { WalletsNetwork } from "../../../features/balances/types";

const getChainsInfo = async (): Promise<{ data: WalletsNetwork[] }> => {
  return await axios.get("/chains").then(handleResponse);
};

export { getChainsInfo };
